import React from 'react';

import Trough from './trough.svg?react';

function FarmbotTroughIcon() {
  return <Trough width={18} style={{ marginTop: -4 }} />;
}

export default FarmbotTroughIcon;
